import type { OfflineRefundPayload, OfflineSaleItem, OfflineSalePayload } from './types.js';

/** Strip FO-only UI fields before persisting or POSTing — backend DTO forbids extras. */
export function sanitizeOfflineSaleItem(item: OfflineSaleItem & Record<string, unknown>): OfflineSaleItem {
  const base: OfflineSaleItem = {
    productId: item.productId,
    productName: item.productName,
    unitPrice: item.unitPrice,
    taxRate: item.taxRate,
    quantity: item.quantity,
    subtotal: item.subtotal,
    productDiscountPercentage: item.productDiscountPercentage,
    productDiscountAmount: item.productDiscountAmount,
  };
  if (item.isFreePrice !== undefined) base.isFreePrice = item.isFreePrice;
  if (item.categoryId !== undefined) base.categoryId = item.categoryId;
  return base;
}

export function sanitizeSalePayload(payload: OfflineSalePayload): OfflineSalePayload {
  return {
    ...payload,
    items: payload.items.map((item) =>
      sanitizeOfflineSaleItem(item as OfflineSaleItem & Record<string, unknown>),
    ),
  };
}

export function sanitizeRefundPayload(payload: OfflineRefundPayload): OfflineRefundPayload {
  const { settled: _settled, ...rest } = payload;
  return {
    ...rest,
    items: rest.items.map((item) =>
      sanitizeOfflineSaleItem(item as OfflineSaleItem & Record<string, unknown>),
    ),
  };
}
